import { render, staticRenderFns } from "./mainContent.vue?vue&type=template&id=1bf20bab&scoped=true"
import script from "./mainContent.vue?vue&type=script&lang=js"
export * from "./mainContent.vue?vue&type=script&lang=js"
import style0 from "./mainContent.vue?vue&type=style&index=0&id=1bf20bab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf20bab",
  null
  
)

export default component.exports